import { render } from "./DashHead.vue?vue&type=template&id=9a6e6a06&scoped=true"
import script from "./DashHead.vue?vue&type=script&lang=js"
export * from "./DashHead.vue?vue&type=script&lang=js"

import "./DashHead.vue?vue&type=style&index=0&id=9a6e6a06&scoped=true&lang=css"

import exportComponent from "/builds/appmart-development-team/appmart-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a6e6a06"]])

export default __exports__